import type { Chain } from '../../../chain';

type NormalizeWalletNameWithChainParams = {
  chain: Chain;
  displayName: string;
};

/**
 * Format the raw wallet name and chain to get the value we can use for
 * verified credentials' `walletName` field.
 */
export const normalizeWalletNameWithChain = ({
  displayName,
  chain,
}: NormalizeWalletNameWithChainParams): string => {
  const sanitizedWalletName = displayName
    .replace(/[^a-zA-Z0-9]/g, '')
    .toLowerCase();

  const chainLowered = chain.toLocaleLowerCase();

  if (sanitizedWalletName.endsWith(chainLowered)) {
    return sanitizedWalletName;
  }

  return `${sanitizedWalletName}${chainLowered}`;
};
